module.exports = __webpack_public_path__ + "static/media/hr.af6feb3b.svg";